import { render, staticRenderFns } from "./BlockView.vue?vue&type=template&id=1944a88a&scoped=true"
import script from "./BlockView.vue?vue&type=script&lang=js"
export * from "./BlockView.vue?vue&type=script&lang=js"
import style0 from "./BlockView.vue?vue&type=style&index=0&id=1944a88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1944a88a",
  null
  
)

export default component.exports